import { Fragment, h } from "preact";
import { useDispatch } from "react-redux";
import { useEffect, useState } from "preact/hooks";
import { useBlocker } from "react-router";

import i18n from "../../i18n.js";
import { createFormData } from "../../services/forms.js";
import projectsApi from "../../api/projects.js";

import BackButton from "../BackButton.jsx";
import Button from "../Button.jsx";
import SuccessState from "./SuccessState.jsx";
import TextField from "../TextField.jsx";
import { sendError } from "../../errors.js";
import { createToastMessage } from "../../store/uiSlice.js";
import UnsavedChangesPrompt from "../UnsavedChangesPrompt.jsx";

const FORM = {
  link: {
    validations: ["required", "url"],
  },
};

export default function ProjectViaLink({ onBack }) {
  const { formData, valid, fieldsFor, onSubmit, changed } = createFormData(
    FORM,
    {}
  );
  const dispatch = useDispatch();

  const [success, setSuccess] = useState(false);
  const [sending, setSending] = useState(false);
  const [formErrors, setFormErrors] = useState({});

  const blocker = useBlocker(
    ({ currentLocation, nextLocation }) =>
      !success && currentLocation.pathname !== nextLocation.pathname && changed
  );
  async function handleSubmit() {
    try {
      setSending(true);
      await projectsApi.createRequestViaLink(formData.link);
      setSuccess(true);
    } catch (err) {
      if (err.errors) {
        setFormErrors(err.errors);
      } else {
        sendError(err);
        createToastMessage(dispatch, {
          type: "error",
          message: i18n.t(
            "component.projects_add.project_via_link.server_error"
          ),
        });
      }
    }
    setSending(false);
  }

  if (success) {
    return <SuccessState />;
  }

  return (
    <>
      <form method="post" action="#" onSubmit={onSubmit(handleSubmit)}>
        <h1 class="t-h5 t-h5--margin">
          {i18n.t("component.projects_add.project_via_link.title")}
        </h1>
        <p class="t-body2 color-shades-charcoal mb-32">
          {i18n.t("component.projects_add.project_via_link.subtitle")}
        </p>

        <div class="mb-80">
          <TextField
            {...fieldsFor("link", {
              serverErrors: formErrors.link,
            })}
            label={i18n.t("component.projects_add.project_via_link.label")}
            info={i18n.t("component.projects_add.project_via_link.info")}
          />
        </div>

        <div>
          <BackButton
            class="mr-2"
            onClick={onBack}
            trackingName="backOnProjectViaLink"
            noIndent
          />
          <Button
            type="submit"
            disabled={sending || !valid}
            trackingName="submitProjectViaLink"
          >
            {i18n.t("actions.submit")}
          </Button>
        </div>
      </form>
      {blocker.state === "blocked" ? (
        <UnsavedChangesPrompt
          acceptButton={i18n.t(
            "component.projects_add.projects_wizard.unsaved_changes_prompt.ok"
          )}
          cancelButton={i18n.t(
            "component.projects_add.projects_wizard.unsaved_changes_prompt.cancel"
          )}
          text={i18n.t(
            "component.projects_add.projects_wizard.unsaved_changes_prompt.text"
          )}
          onAccept={() => blocker.proceed()}
          onCancel={() => blocker.reset()}
        />
      ) : null}
    </>
  );
}
